import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import VideoForm from "../../components/forms/VideoForm";
import BasePage from "../common/BasePage";
import { useToast } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

export default function NewVideoPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const toast = useToast();
  const onSuccess = useCallback(() => {
    navigate(`./..`);
    toast({
      title: t("new_video_page.video_created"),
      description: t("new_video_page.video_created_message"),
      status: "success",
      isClosable: true,
    });
  }, [navigate, t, toast]);

  const onError = useCallback(() => {
    toast({
      title: t("new_video_page.video_error"),
      description: t("new_video_page.video_error_message"),
      status: "error",
      isClosable: true,
    });
  }, [t, toast]);

  return (
    <BasePage title={t("new_video_page.new_video")}>
      <VideoForm onSuccess={onSuccess} onError={onError} />
    </BasePage>
  );
}
